// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1p0-B","vLegacy":"SelectSecondary_vLegacy__slVyn","error":"SelectSecondary_error__55W1L","disabled":"SelectSecondary_disabled__W4w_d"};